module.exports = __webpack_public_path__ + "static/media/15-1.8c3c5ab2.mp3";